import { FUND_EXIT_ENTERPRISE_ALIAS, FUND_EXIT_EQUITY_ALIAS } from 'common/constants/allocations';
import { getEnterpriseValueFormula, getEquityValueFormula } from 'common/formulas/math.js/ENTERPRISE_AND_EQUITY_VALUE';
import { AfterCellsChanged, EvaluatedCell } from 'models/interfaces/spreadsheet-types/core-types';
import {
  EXIT_ENTERPRISE_VALUE_ALIAS,
  EXIT_EQUITY_ALIAS,
  LESS_DEBT_ALIAS,
  PLUS_CASH_ALIAS
} from 'pages/Waterfall/SpreadsheetConfig/constants';

export const inputSheetAfterCellsChanged: AfterCellsChanged = (
  initialChanges,
  cells,) => {
  if (initialChanges.length === 0) {
    throw new Error('No changes detected');
  }
  const change = initialChanges[0];
  const { cell } = change;

  const changes = [...initialChanges];
  //   if the cell.alias is the equity value, then we will update the cell with an alias of enterprise value
  function updateEnterpriseValue(equityValueCell: EvaluatedCell) {
    const cashCell = Object.values(cells).find(c => c.alias === PLUS_CASH_ALIAS);
    const debtCell = Object.values(cells).find(c => c.alias === LESS_DEBT_ALIAS);
    const enterpriseValueCell = Object.values(cells).find(c => c.alias === EXIT_ENTERPRISE_VALUE_ALIAS);
    if (enterpriseValueCell && cashCell && debtCell) {
      const expr = getEnterpriseValueFormula(equityValueCell.key, cashCell.key, debtCell.key);
      changes.unshift({cell: enterpriseValueCell, value: `=${expr}`});
    }
  }
  function updateEquityValue(enterpriseValueCell: EvaluatedCell) {
    const cashCell = Object.values(cells).find(c => c.alias === PLUS_CASH_ALIAS);
    const debtCell = Object.values(cells).find(c => c.alias === LESS_DEBT_ALIAS);
    const equityValueCell = Object.values(cells).find(c => c.alias === EXIT_EQUITY_ALIAS);
    if (equityValueCell && cashCell && debtCell) {
      const expr = getEquityValueFormula(enterpriseValueCell.key, cashCell.key, debtCell.key);
      changes.unshift({cell: equityValueCell, value: `=${expr}`});
    }
  }

  function updateEnterpriseValueWithRate(enterpriseValueCell: EvaluatedCell<object, object, object, object> | undefined ) {
    if (enterpriseValueCell) {
      const expr = `=${cell.key} / ExchangeRateSheet.fundExchangeRate`;
      changes.unshift({cell: enterpriseValueCell, value: expr});
      updateEquityValue(enterpriseValueCell);
    }
  }

  function updateEquityValueWithRate(equityValueCell: EvaluatedCell | undefined) {
    if (equityValueCell) {
      const expr = `=${cell.key} / ExchangeRateSheet.fundExchangeRate`;
      changes.unshift({cell: equityValueCell, value: expr});
      updateEnterpriseValue(equityValueCell);
    }
  }

  function updateFundEnterpriseValueWithRate(enterpriseValueCell: EvaluatedCell | undefined) {
    if (enterpriseValueCell) {
      const expr = `=${cell.key} * ExchangeRateSheet.fundExchangeRate`;
      changes.unshift({cell: enterpriseValueCell, value: expr});
    }
  }

  function updateFundEquityValueWithRate(equityValueCell: EvaluatedCell | undefined) {
    if (equityValueCell) {
      const expr = `=${cell.key} * ExchangeRateSheet.fundExchangeRate`;
      changes.unshift({cell: equityValueCell, value: expr});
    }
  }

  //     with a formula that will calculate the enterprise value and vice versa
  if (cell.alias === EXIT_EQUITY_ALIAS) {
    updateEnterpriseValue(cell);
    const fundEquityValueCell = Object.values(cells).find(c => c.alias === FUND_EXIT_EQUITY_ALIAS);
    updateFundEquityValueWithRate(fundEquityValueCell)
  }

  if (cell.alias === EXIT_ENTERPRISE_VALUE_ALIAS) {
    updateEquityValue(cell);
    const fundEnterpriseValueCell = Object.values(cells).find(c => c.alias === FUND_EXIT_ENTERPRISE_ALIAS);
    updateFundEnterpriseValueWithRate(fundEnterpriseValueCell)
  }

  if (FUND_EXIT_EQUITY_ALIAS === cell.alias) {
    const equityValueCell = Object.values(cells).find(c => c.alias === EXIT_EQUITY_ALIAS);
    updateEquityValueWithRate(equityValueCell);
  }

  if (FUND_EXIT_ENTERPRISE_ALIAS === cell.alias) {
    const enterpriseValueCell = Object.values(cells).find(c => c.alias === EXIT_ENTERPRISE_VALUE_ALIAS);
    updateEnterpriseValueWithRate(enterpriseValueCell);
  }
  return changes
}